import * as types from "../types/customerDisplays"

const initialState = []

const customerDisplayReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_CUSTOMER_DISPLAY:
      return [...state, action.customerDisplay]
    case types.EDIT_CUSTOMER_DISPLAY:
      return state.map((cd) =>
        cd.ipAddress === action.ipAddress ?
          { ...cd, ...action.data } : cd
      )
    case types.DELETE_CUSTOMER_DISPLAY:
      return state.filter((cd) =>
        cd.ipAddress !== action.ipAddress
      )
    default:
      return state
  }
}

export default customerDisplayReducer